export default "__VITE_ASSET__OiSg8KwR__"